/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GridColDef,
  GridRenderCellParams,
  GridValueFormatterParams
} from '@mui/x-data-grid-premium';
import { baseCell, booleanCell, currencyCell } from 'components/cells';
import {
  filterOperators,
  dateFilterOperators,
  booleanFilterOperators,
  numberFilterOperators
} from 'components/enhanced';
import { booleanValueFormatter } from 'components/enhanced/data-grid/utils/helpers';
import { currencyFormatter } from 'components/helpers/currency-formatter';
import FileUploader from 'components/ui/file-uploader/FileUploader';
import { SectionTitle } from 'components/ui/typography';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { transportDocumentService } from '../transport-documents/TransportDocument/api/transport-document.service';

export function EquipmentInvoicesColumns(onUploadSuccess): GridColDef[] {
  const { t } = useTranslation();

  const columns: GridColDef[] = [
    {
      field: 'ref',
      headerName: t(`entities.ddt.invoice_ref`),
      width: 150,
      filterOperators,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <NavLink to={`${params.row?.id}`}>
          <SectionTitle>{params.value}</SectionTitle>
        </NavLink>
      )
    },
    {
      field: 'date',
      headerName: t(`global.date`),
      width: 100,
      filterOperators: dateFilterOperators,
      renderCell: baseCell
    },
    {
      field: 'closed',
      align: 'center',
      headerName: t(`entities.ddt.closed`),
      width: 150,
      filterOperators: booleanFilterOperators,
      renderCell: booleanCell(t)
    },
    {
      field: 'contract_code',
      headerName: t('global.contract'),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'supplier',
      headerName: t('global.supplier'),
      filterOperators,
      width: 150,
      renderCell: baseCell
    },
    {
      field: 'expected_amount',
      headerName: t(`entities.ddt.expected_amount`),
      width: 150,
      filterOperators: numberFilterOperators,
      valueFormatter: (params: GridValueFormatterParams) => {
        return currencyFormatter(params.value);
      },
      renderCell: currencyCell
    },
    {
      field: 'amount',
      headerName: t(`entities.ddt.amount`),
      width: 150,
      filterOperators: numberFilterOperators,
      valueFormatter: (params: GridValueFormatterParams) => {
        return currencyFormatter(params.value);
      },
      renderCell: currencyCell
    }
  ];

  ['invoice_file', 'invoice_revision_file'].forEach((file) => {
    columns.push({
      field: file,
      headerName: t(`entities.ddt.${file}`),
      filterOperators,
      filterable: false,
      sortable: false,
      width: 70,
      valueFormatter: booleanValueFormatter,
      renderCell: (params: GridRenderCellParams<any, any>) => (
        <FileUploader
          onUploadSuccess={onUploadSuccess}
          service={transportDocumentService}
          entityId={params.row?.id}
          attachmentName={file}
          filename={params.value}
        />
      )
    });
  });

  return columns;
}
